import { useEffect } from 'preact/hooks';
import { AcoesPage } from '../admin/AcoesPage';
import { AuditoriaPage } from '../admin/AuditoriaPage';
import { DadosOficiaisPage } from '../admin/DadosOficiaisPage';
import { ImpactoPage } from '../admin/ImpactoPage';
import { PesquisasPage } from '../admin/PesquisasPage';
import { ProjetosPage } from '../admin/ProjetosPage';
import { SecretariasPage } from '../admin/SecretariasPage';
import { UsuariosPage } from '../admin/UsuariosPage';
import { ROTULO_PERFIL } from '../format';
import { menuDoPerfil } from '../permissoes';
import { semInternet } from '../pwa';
import { irPara, rota } from '../router';
import { fazerLogout } from '../session';
import { usuario } from '../state';
import { Avisos, DialogoConfirmar } from '../ui';
import { BotaoInstalar } from './Instalar';
import { FaixaInspecao, PesquisadorInspecionado } from './Inspecao';
import { BarraInferior } from './NavegacaoMovel';
import { Painel } from './Painel';
import { BotaoTema } from './Tema';

/** Moldura do sistema: menu por perfil + a tela escolhida. Rotas que o perfil não pode abrir voltam ao painel. */
export function Shell() {
  const u = usuario.value!;
  const menu = menuDoPerfil(u.perfil);
  const atual = rota.value;
  const permitida = menu.some((m) => m.id === atual);

  useEffect(() => {
    if (!permitida && menu[0]) irPara(menu[0].id);
  }, [permitida, menu.length]);

  const id = permitida ? atual : (menu[0]?.id ?? 'painel');

  // Trocar de tela começa no topo (como num aplicativo), em vez de herdar a rolagem da tela anterior.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  // Pesquisador só aparece aqui durante uma inspeção (o app de campo não é aberto): não tem telas do painel.
  const soPesquisador = u.perfil === 'PESQUISADOR';
  const tituloMovel = menu.find((m) => m.id === id)?.rotulo ?? 'MAPAS';

  return (
    <div class="shell">
      <header class="cabecalho">
        <FaixaInspecao />
        <nav class="nav" aria-label="Principal">
          <strong class="nav-marca">MAPAS</strong>
          <span class="nav-titulo-movel" aria-hidden="true">{soPesquisador ? 'Pesquisador' : tituloMovel}</span>
          <ul class="nav-itens">
            {menu.map((m) => (
              <li key={m.id}>
                <a href={`#/${m.id}`} class={id === m.id ? 'nav-item ativo' : 'nav-item'} aria-current={id === m.id ? 'page' : undefined}>
                  {m.rotulo}
                </a>
              </li>
            ))}
          </ul>
          <div class="nav-acoes">
            <BotaoInstalar class="botao compacto" rotulo="Instalar app" />
            <BotaoTema />
          </div>
          <div class="usuario">
            <span title={u.email}>
              {u.nome} · {ROTULO_PERFIL[u.perfil]}
            </span>
            {!u.inspecionadoPor && (
              <button type="button" class="link" onClick={() => void fazerLogout()}>
                Sair
              </button>
            )}
          </div>
        </nav>
      </header>

      {semInternet.value && <p class="faixa-offline" role="status">Sem conexão com a internet. Você vê os dados já carregados; para alterar algo, volte a ficar online.</p>}

      {soPesquisador && <PesquisadorInspecionado />}
      {!soPesquisador && id === 'painel' && <Painel />}
      {!soPesquisador && id === 'impacto' && <ImpactoPage />}
      {!soPesquisador && id === 'acoes' && <AcoesPage />}
      {!soPesquisador && id === 'projetos' && <ProjetosPage />}
      {!soPesquisador && id === 'secretarias' && <SecretariasPage />}
      {!soPesquisador && id === 'usuarios' && <UsuariosPage />}
      {!soPesquisador && id === 'pesquisas' && <PesquisasPage />}
      {!soPesquisador && id === 'auditoria' && <AuditoriaPage />}
      {!soPesquisador && id === 'dados' && <DadosOficiaisPage />}

      <BarraInferior menu={menu} atual={id} />
      <Avisos />
      <DialogoConfirmar />
    </div>
  );
}
